export default __webpack_public_path__ + "static/media/img_baseCrochet_grey_p.900d168f.jpg";